module.exports = __webpack_public_path__ + "static/landing-bg-be1c1d2b130c59d2fa0a4200b2e70438.jpg";